import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'eqms.changeControlDetails/:id',
    loadChildren: () =>
      import('./change-control-details/change-control-details.module').then(
        (m) => m.ChangeControlDetailsModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./change-control-library/change-control-library.module').then(
        (m) => m.ChangeControlLibraryModule
      ),
  },
  {
    path: 'change-control-queues',
    loadChildren: () =>
      import('./change-control-queues/change-control-queues.module').then(
        (m) => m.ChangeControlQueuesModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangeControlRoutingModule {}
